<template>
    <div id="invoice-ticket-component">
        <div class="row">
            <form id="ticket_form" class="ticket_form">
                <div v-for="(row, index) in invoice_array" :key="index">
                    <input type="hidden" name="invoice_array[]" :value="row">
                </div>
                <input type="hidden" name="type_model" id="" :value="model_type">
                <input type="hidden" name="supplier_id" id="" :value="supplier_id">

                <div class="col-12 col-sm-12">
                    <div class="alert alert-info text-center">
                        <p>
                            Se debe seleccionar los dos archivos del complemento el XML y el PDF
                        </p>
                    </div>
                    <div class="fotoUploader">
                    <span class="btn btn-file">
                        Documento <br> <i class="fas fa-upload"></i>
                        <input type="file"
                               accept=".xml,.pdf"
                               name="facturas[]"
                               id="file_factura"
                               multiple data-label="facturas"
                               class="required"
                               v-on:change="getBills">
                    </span>
                        <span class="label-file-papeleria alert alert-info factura_name"></span>
                    </div>
                </div>
                <div class="col-12 col-sm-12">
                    <p class="fotoUploader">
                        <strong>Formatos permitidos: .pdf y .xml, con un peso máximo de 3mb</strong>
                    </p>
                </div>
            </form>
            <div class="col-12 col-sm-12">
                <button id="dyn-button" class="btn btn-primary addNote" v-on:click="guardarTicket()">
                    Subir Archivos
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";
import {getFormData} from "../../Utils/getDataForm";
import {paymentComplementService} from "../../Services/PaymentComplement.service";

export default {
    name: 'complement-invoice',
    mixins: [myMixins],
    props: {
        invoice_array: {
            type: Array,
            required: true
        },
        supplier_id: {
            type: Number,
            comments: 'Es el id del proveedor al que se le cargaran los complementos',
            required: false
        },
        role_id: {
            type: Number,
            comments: 'Es el rol del usuario que esta cargando el complemento, se usa para obtener el directorio donde se guarda el archivo de la factura',
            required: false
        },
        type_model: {
            type: String,
            comments: 'Se le pasa el modelo para que lo use para la ruta donde guardara el archivo, a veces se usa el role_id pero en otros casos se usa el modelo directo',
            required: false
        }

    },
    data() {
        return {
            modificar: false,
            tituloBtn: 'Agregar Documento',
            model_type: '',
        }
    },
    methods: {
        async guardarTicket() {
            //console.log('guardarTicket');
            let resp = '';
            let respVal = this.valFormulariosV3('ticket_form');
            if (respVal) {
                this.disableSubmitBtn(true);
                //DINAMICAMENTE ASIGNAMOS EL VALOR DEL CAMPO A GUARDAR
                //this.ticket[myField] = this.item;
                const formData = getFormData('ticket_form');
                //console.log('formData', formData);
                resp = await paymentComplementService.saveOne(formData, {
                    isForm: true,
                    onUploadProgress: this.onUploadProgress
                });

                this.getAlert(resp.process, true);
                this.disableSubmitBtn(false);
            }
            this.modificar = false;
        },

        getBills(event) {
            this.getNameFile(event, 'factura_name');
        },
    },
    mounted() {
        if (this.role_id === undefined) {
            this.model_type = this.roleModels[this.role_id];
            console.log('model_type', this.role_id);
        } else {
            console.log('type_model', this.type_model);
            this.model_type = this.type_model;
        }

    },
}
</script>
